document.addEventListener('DOMContentLoaded', function () {
    const headerGroup = document.querySelector('.shopify-section-group-header-group');
    const pageContent = document.querySelector('#main');

    if (!headerGroup || !pageContent) return;
    function loadPageContent(url) {
        document.body.classList.add('loading');
        return fetch(url)
            .then(response => {
                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }
                return response.text();
            })
            .then(html => {
                const parser = new DOMParser();
                const doc = parser.parseFromString(html, 'text/html');

                const newPageContent = doc.querySelector('#main');
                if (newPageContent) {
                    pageContent.innerHTML = newPageContent.innerHTML;
                }
                history.pushState(null, '', url);
                document.body.classList.remove('loading');

const swatches = document.querySelectorAll('.block-swatch');
swatches.forEach((swatch, index) => {
  swatch.addEventListener('click', () => {
    const inputValue = swatch.querySelector('input').value;
      const sizeValue = document.querySelector('#size-value-cici');
      sizeValue.textContent = swatch.querySelector('.block-swatch__item').textContent.trim();
    });
  });
applyTabLogic();
 adjustSliders();
  adjustaaaa();
 initializeVideoLink();    
            })
            .catch(error => {
                console.error('Error refreshing content:', error);
                alert('Page loading failed, please try again later.');
                document.body.classList.remove('loading');
            });
    }
    document.addEventListener('click', function (event) {
        const target = event.target.closest('.color-swatch-leo');
        if (target) {
            event.preventDefault();
            const url = target.getAttribute('data-handle'); 
            if (!url) {
                console.error('No URL found on the target element.');
                return;
            }
            if (document.body.classList.contains('loading')) return;
            loadPageContent(url);
        }
    });
    window.addEventListener('popstate', function () {
        const url = location.href;
        if (document.body.classList.contains('loading')) return;
        loadPageContent(url);
    });
});